import { RefObject, useEffect, useState } from 'react'

const useElementMeasurements = (
  ref: RefObject<HTMLElement>
): { height: number; width: number } => {
  // Create a ref to the parent element
  // State to store the width of the parent element
  const [parentWidth, setParentWidth] = useState<number>(0)
  const [parentHeight, setParentHeight] = useState<number>(0)
  useEffect(() => {
    // Function to update the width
    const updateWidth = () => {
      if (ref.current) {
        setParentWidth(ref.current.offsetWidth)
        setParentHeight(ref.current.offsetHeight)
      }
    }
    // Update the width initially
    updateWidth()
    // Add event listener for window resize to update width
    window.addEventListener('resize', updateWidth)
    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener('resize', updateWidth)
    }
  }, [ref])

  return { width: parentWidth, height: parentHeight }
}

export default useElementMeasurements
